import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 구매 확인 실패 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 통신환경 문제나 시스템 오류로")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 구매확인에 실패했습니다 😥")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 불편을 드려 대단히 죄송합니다.")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 구매를 취소하고 다시 시도해보시거나")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 1:1 문의 주시면 빠르게 해결하겠습니다.")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 1:1 문의 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 구매 취소 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 닫기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_footer = _resolveComponent("ag-footer")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createBlock(_component_ag_content, { height: "100%" }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        dp: "flex",
        direction: "column",
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            dp: "flex",
            direction: "column",
            "align-items": "center",
            "justify-content": "center",
            height: "100%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_img, {
                width: "40px",
                height: "40px",
                src: _ctx.dealInfo.partnershipLogo
              }, null, 8, ["src"]),
              _createVNode(_component_ag_text, {
                "padding-top": "8px",
                typography: "tit16b"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.dealInfo.partnershipName), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, {
                "padding-top": "32px",
                typography: "tit24b"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, {
                color: "gray2",
                "text-align": "center",
                p: "32px 20px 0px 20px",
                typography: "tit18r"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _hoisted_3,
                  _hoisted_4,
                  _hoisted_5,
                  _hoisted_6,
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_footer, {
        p: "20px",
        mb: "safeAreaBottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            dp: "flex",
            gap: "sp6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_button, {
                block: "lg",
                corner: "10px",
                height: "100%",
                width: "100%",
                outline: "primary",
                onClickCapture: _ctx.openChannelTalk
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["onClickCapture"]),
              _createVNode(_component_ag_button, {
                block: "lg",
                corner: "10px",
                height: "100%",
                width: "100%",
                outline: "primary",
                onClickCapture: _ctx.cancelToBuy
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["onClickCapture"]),
              _createVNode(_component_ag_button, {
                block: "lg",
                corner: "10px",
                height: "100%",
                width: "100%",
                onClickCapture: _ctx.onClose
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["onClickCapture"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}